import { authComputed, authMethods } from './state/helpers';
import PlanPricing from '@/components/plan-pricing.vue';
import usePlanPrice from '@/composable/plan-price';
import useNotifications from '@/composable/notifications';
import { layoutTypeToComponentMapper } from '@/layouts/layoutHelper';
import i18n from '@/i18n';
import useProjects from '@/composable/project';
const {
  fetchIfNotificationExist
} = useNotifications();
const {
  fetchPlans
} = usePlanPrice();
const {
  fetchTenantInfoPlans
} = usePlanPrice();
const {
  toggleShouldRefresh
} = useProjects();
export default {
  name: 'App',
  computed: {
    layoutTypeToComponentMapper() {
      return layoutTypeToComponentMapper;
    }
  },
  components: {
    PlanPricing
  },
  data() {
    return {
      dialogVisible: true,
      cacheVersion: ''
    };
  },
  methods: {
    ...authMethods,
    ...authComputed,
    fetchData() {
      this.$store.dispatch('groups/fetchGroups');
      this.$store.dispatch('user/getAllUser');
    },
    bumpCache() {
      this.cacheVersion = Date.now();
      // localStorage.setItem('keepAliveRefreshAt', this.cacheVersion);
    }
  },
  beforeUnmount() {
    if (this.refreshTimer) clearInterval(this.refreshTimer);
  },
  mounted() {
    // Theme is now bootstrapped synchronously in main.js, before Vue mounts.
    const savedLang = localStorage.getItem('lang');
    if (savedLang) i18n.global.locale = savedLang;
  },
  created() {
    // const MINUTES = 30 * 60 * 1000; //30   minutes in ms
    // this.cacheVersion = Date.now();
    // toggleShouldRefresh();

    // const lastRefresh = localStorage.getItem('keepAliveRefreshAt');

    // if (!lastRefresh || Date.now() - lastRefresh > MINUTES) {
    //   // expired -> bump version
    //   this.cacheVersion = Date.now();
    //   toggleShouldRefresh();
    //   localStorage.setItem('keepAliveRefreshAt', Date.now());
    // } else {
    //   // still valid -> reuse old version
    //   this.cacheVersion = lastRefresh;
    // }

    // // 🔄 Keep refreshing every 5 minutes
    // this.refreshTimer = setInterval(() => {
    //   this.bumpCache();
    // }, MINUTES);

    if (localStorage.getItem('access_token')) {
      fetchTenantInfoPlans();
      fetchIfNotificationExist();
      fetchPlans();
      this.getUsersData();
      this.fetchData();
    }
  }
};